import * as Yup from "yup";

export const validationEnterpriseRegister = Yup.object().shape({
	email: Yup.string().email("El formato del correo es incorrecto").required("El corre electrónico es obligatorio"),
	password: Yup.string().min(8, "La contraseña debe tener al menos 8 caracteres").required("La contraseña es obligatoria"),
	// .matches(
	// 	// eslint-disable-next-line
	// 	/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
	// 	"Debe contener 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial"
	// ),
	name: Yup.string().min(1, "El nombre debe tener al menos 1 caracter").required("El nombre es obligatorio"),
	nameProyect: Yup.string().min(1, "El proyecto debe tener al menos 1 caracter").required("El proyecto es obligatorio"),
	userName: Yup.string().min(1, "El nombre debe tener al menos 1 caracter").required("El nombre es obligatorio"),
	lastName: Yup.string().min(1, "El nombre debe tener al menos 1 caracter").required("El apellido es obligatorio"),
	typeUser: Yup.string().required("El producto es necesario"),
	// telphone: Yup.string()
	//     .required("El teléfono es obligatorio")
	//     .matches(
	//         /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
	//         "El número de teléfono no es válido"
	//     )
	//     .length(10, "El teléfono debe tener 10 dígitos"),
	// address: Yup.string()
	//     .required("La dirección es obligatoria"),
	// age: Yup.number()
	//     .positive()
	//     .integer()
	//     .min(18, "La edad debe ser mayor a 18 años")
	//     .required("La edad es obligatoria")
	//     .typeError("La edad debe contener sólo números enteros positivos"),
	// accept: Yup.boolean()
	//     .required("Debe aceptar los términos y condiciones")
	//     .oneOf([true], "Debe aceptar los términos y condiciones")
});
